export default __webpack_public_path__ + "static/media/bg-1.e27aafe2.jpg";